module.exports = __webpack_public_path__ + "img/02_Explosion_iPad_L.a5af06fe.jpg";